export default __webpack_public_path__ + "static/logo-91da3a6745db21c426343803bec3af42.png";